import { type ReactNode } from 'react';

type Props = {
  /** Spinner, status icon or app logo shown above the title. */
  visual: ReactNode;
  title: string;
  subtitle?: string;
  /** Actions or extra content below the text. */
  children?: ReactNode;
};

/**
 * HostedStatusBlock — A centred status: a visual, a title, an optional subtitle and
 * optional actions. Used for loading, waiting, pairing, done and abort states.
 */
export default function HostedStatusBlock({
  visual,
  title,
  subtitle,
  children,
}: Props) {
  return (
    <div className="flex flex-1 items-center justify-center w-full">
      <div className="flex flex-col items-center gap-4 text-center max-w-lg w-full">
        {visual}
        <div className="flex flex-col gap-2">
          <h2 className="text-2xl font-semibold text-foreground">{title}</h2>
          {subtitle && (
            <p className="text-sm text-muted-foreground whitespace-pre-line">
              {subtitle}
            </p>
          )}
        </div>
        {children}
      </div>
    </div>
  );
}
